import { ProgressButton } from "../display/ProgressButton.js";
import { Stage } from "../display/Stage.js";
import { Data } from "../model/Data.js";

export interface TestAppOptions {
    element: HTMLDivElement;
}

export class TestApp {

    private _element: HTMLDivElement;
    private _stage: Stage;
    private _options: TestAppOptions;
    private _data: Data;

    constructor(options: TestAppOptions) {

        this._options = options;
        this._element = options.element;

        this.init();
    }

    private async init() {
        this._stage = new Stage({
            element: this._element,
            className: "test-app",
            layout: "responsive"
        });

        try {
            // var cover = new Cover({
            //     container: this._stage.content
            // });
            // this._stage.content.addEventListener("click", () => {
            //     cover.visible = !cover.visible;
            // });

            this._data = new Data();
            try {
                await this._data.load(this._element.getAttribute("data-data"));
            } catch (error) {
                var err = error as Error;
                console.error(error);
                // this._preloader.showError(err?.message || "Es ist ein Unbekannter Fehler aufgetreten.");
                return;
            }

            new ProgressButton({
                container: this._stage.content,
                label: "TEST Box Fontsize normal",
                shape: "box",
                fontSize: "normal",
                onClick: (btn) => {
                    btn.play(1);
                }
            });

            new ProgressButton({
                container: this._stage.content,
                label: "Dia Small",
                shape: "dia-small",
                onClick: (btn) => {
                    btn.play(1);
                }
            });

            new ProgressButton({
                container: this._stage.content,
                label: "Dia Big",
                shape: "dia-big",
                onClick: (btn) => {
                    btn.play(1);
                }
            });

            new ProgressButton({
                container: this._stage.content,
                label: "Box",
                shape: "box",
                onClick: (btn) => {
                    btn.play(1);
                }
            });



            //         const colors = new Colors();
            //         let confetti = new Confetti({
            //             container: this._stage.foreground,
            //             colors: colors.getAll(),
            //             labels: this._data.labels
            //         });
            //         confetti.title = "Toll gemacht!";
            //         confetti.subtitle = `Jetzt geht es weiter
            // mit Teil 2.`;
            //         confetti.visible = true;

            //         this._stage.element.addEventListener("click", () => {
            //             confetti.boxed = !confetti.boxed;
            //         });

        } catch (error) {
            var err = error as Error;
            console.error(error);
            this._stage.preloader.showError(err?.message || "Es ist ein Unbekannter Fehler aufgetreten.");
            return;
        }

        this._stage.preloader.hide();
    }
}